import React from "react"
import styled from 'styled-components'

const ImgLoading = styled.img`
  margin: auto;
  vertical-align: middle;
  object-fit: contain;
  object-position: left;
  height: auto;
  max-height: 200px;
  display: inline-block;
`
// const ImgMiniLoading = styled.img`
//   vertical-align: middle;
//   object-fit: contain;
//   object-position: center;
//   width: 42px;
//   height: auto;
//   display: inline-block;
// `

class Loading extends React.Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount () {
      var imgSrc=document.querySelector("#imgLoading").src;
      document.querySelector("#imgLoading").src=imgSrc;
  }


  render() {
    return <div className="div-loading" style={{display: 'flex'}}>
      <ImgLoading id='imgLoading' className="img-loading" src={"/img/logo-startupitalia_2.gif"}/>
    </div>
  }
}

export default Loading
